// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4759) return "static/chunks/4759.ae4b084dd70a13e0.js";
	if (chunkId === 6967) return "static/chunks/6967.b49a415a355ccf74.js";
	if (chunkId === 3384) return "static/chunks/3384.9be0253e70d2300d.js";
	if (chunkId === 1822) return "static/chunks/1822.1a1417fc5400292e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1867":"099d78250e3fc1ff","5084":"4f4395c44f5994b8","5723":"574216c51ab8157d","5973":"d0695a3776e6e544","8280":"2eebf22cc58abc1e","9433":"16f43693ea112a77","9764":"80c494c3801ddb55","9838":"0b03713583474cef"}[chunkId] + ".js";
};